import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Search, X, Check, CheckSquare, Square, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CATEGORIES_LIST = [
  { value: 'nouveautes', label: 'Nouveautés' },
  { value: 'fiction', label: 'Fiction' }, { value: 'documentaire', label: 'Documentaire' },
  { value: 'jeunesse', label: 'Jeunesse' }, { value: 'originals', label: 'Originals Maya+' },
];

export const ALL_COUNTRIES = [
  'Afghanistan','Afrique du Sud','Albanie','Algérie','Allemagne','Andorre','Angola','Antigua-et-Barbuda','Arabie saoudite','Argentine','Arménie','Australie','Autriche','Azerbaïdjan',
  'Bahamas','Bahreïn','Bangladesh','Barbade','Belgique','Belize','Bénin','Bhoutan','Biélorussie','Birmanie','Bolivie','Bosnie-Herzégovine','Botswana','Brésil','Brunei','Bulgarie','Burkina Faso','Burundi',
  'Cambodge','Cameroun','Canada','Cap-Vert','Centrafrique','Chili','Chine','Chypre','Colombie','Comores','Congo','Corée du Nord','Corée du Sud','Costa Rica',"Côte d'Ivoire",'Croatie','Cuba',
  'Danemark','Djibouti','Dominique','Égypte','Émirats arabes unis','Équateur','Érythrée','Espagne','Estonie','Eswatini','États-Unis','Éthiopie',
  'Fidji','Finlande','France','Gabon','Gambie','Géorgie','Ghana','Grèce','Grenade','Guatemala','Guinée','Guinée équatoriale','Guinée-Bissau','Guyana',
  'Haïti','Honduras','Hongrie','Inde','Indonésie','Irak','Iran','Irlande','Islande','Israël','Italie','Jamaïque','Japon','Jordanie',
  'Kazakhstan','Kenya','Kirghizistan','Kiribati','Koweït','Laos','Lesotho','Lettonie','Liban','Liberia','Libye','Liechtenstein','Lituanie','Luxembourg',
  'Macédoine du Nord','Madagascar','Malaisie','Malawi','Maldives','Mali','Malte','Maroc','Maurice','Mauritanie','Mexique','Micronésie','Moldavie','Monaco','Mongolie','Monténégro','Mozambique',
  'Namibie','Nauru','Népal','Nicaragua','Niger','Nigeria','Norvège','Nouvelle-Zélande','Oman','Ouganda','Ouzbékistan',
  'Pakistan','Palaos','Palestine','Panama','Papouasie-Nouvelle-Guinée','Paraguay','Pays-Bas','Pérou','Philippines','Pologne','Portugal','Qatar',
  'République dominicaine','République tchèque','Roumanie','Royaume-Uni','Russie','Rwanda',
  'Saint-Kitts-et-Nevis','Saint-Vincent-et-les-Grenadines','Sainte-Lucie','Salomon','Salvador','Samoa','São Tomé-et-Príncipe','Sénégal','Serbie','Seychelles','Sierra Leone','Singapour','Slovaquie','Slovénie','Somalie','Soudan','Soudan du Sud','Sri Lanka','Suède','Suisse','Suriname','Syrie',
  'Tadjikistan','Tanzanie','Tchad','Thaïlande','Timor oriental','Togo','Tonga','Trinité-et-Tobago','Tunisie','Turkménistan','Turquie','Tuvalu',
  'Ukraine','Uruguay','Vanuatu','Vatican','Venezuela','Viêt Nam','Wallis-et-Futuna','Yémen','Zambie','Zimbabwe'
];

export const MEDIA_SPECS = {
  poster_url: { label: 'Poster vertical', dims: '1000 x 1500 px', w: 1000, h: 1500, kind: 'image', exact: true, maxBytes: 2 * 1024 * 1024, formats: 'JPG, PNG, WebP', maxSize: '2 Mo', accept: 'image/jpeg,image/png,image/webp', desc: 'Affiche du contenu dans les listes et catalogues (style affiche de cinéma)' },
  banner_url: { label: 'Banner horizontal', dims: '1920 x 1080 px', w: 1920, h: 1080, kind: 'image', exact: true, maxBytes: 3 * 1024 * 1024, formats: 'JPG, PNG, WebP', maxSize: '3 Mo', accept: 'image/jpeg,image/png,image/webp', desc: 'Image de fond dans la modale de détails et les rangées de catégories au survol' },
  hero_url: { label: 'Hero image', dims: '2560 x 1440 px', w: 2560, h: 1440, kind: 'image', exact: true, maxBytes: 5 * 1024 * 1024, formats: 'JPG, PNG, WebP', maxSize: '5 Mo', accept: 'image/jpeg,image/png,image/webp', desc: 'Grande image en haut de la page d\'accueil (bannière héro plein écran)' },
  mobile_banner_url: { label: 'Bannière mobile (portrait)', dims: '1080 x 1620 px', w: 1080, h: 1620, kind: 'image', exact: true, maxBytes: 500 * 1024, formats: 'JPG, WebP', maxSize: '500 Ko', accept: 'image/jpeg,image/webp', desc: 'Image portrait 2:3 pour la page de sélection de profil sur l\'app mobile' },
  tv_banner_url: { label: 'Bannière TV (Qui est-ce ?)', dims: '1920 x 1080 px', w: 1920, h: 1080, kind: 'image', exact: true, maxBytes: 3 * 1024 * 1024, formats: 'JPG, PNG, WebP', maxSize: '3 Mo', accept: 'image/jpeg,image/png,image/webp', desc: 'Bannière paysage adaptée TV qui défile sur l\'écran de sélection des profils de l\'app TV (affichée avec le Logo titre)' },
  tv_screensaver_url: { label: 'Écran de veille TV', dims: '1920 x 1080 px', w: 1920, h: 1080, kind: 'image', exact: true, maxBytes: 3 * 1024 * 1024, formats: 'JPG, PNG, WebP', maxSize: '3 Mo', accept: 'image/jpeg,image/png,image/webp', desc: 'Affiche plein écran utilisée dans le diaporama de l\'écran de veille de l\'app TV (fallback : Banner horizontal)' },
  logo_url: { label: 'Logo titre', dims: '800 x 300 px', w: 800, h: 300, kind: 'image', exact: true, maxBytes: 1 * 1024 * 1024, formats: 'PNG (transparent)', maxSize: '1 Mo', accept: 'image/png,image/webp', desc: 'Logo/titre stylisé affiché par-dessus la bannière héro (remplace le titre texte)' },
  thumbnail_url: { label: 'Miniature (16:9)', dims: '640 x 360 px', w: 640, h: 360, kind: 'image', exact: true, maxBytes: 1 * 1024 * 1024, formats: 'JPG, PNG, WebP', maxSize: '1 Mo', accept: 'image/jpeg,image/png,image/webp', desc: 'Vignette dans les rangées horizontales, le lecteur en pause, et les résultats de recherche' },
  trailer_url: { label: 'Bande annonce', dims: '1920 x 1080 px', w: 1920, h: 1080, kind: 'video', exact: false, maxBytes: 500 * 1024 * 1024, formats: 'MP4, WebM, MOV', maxSize: '500 Mo', accept: 'video/mp4,video/webm,video/quicktime' },
  video_url: { label: 'Vidéo principale', dims: '1920 x 1080 px (min)', kind: 'video', exact: false, maxBytes: 20 * 1024 * 1024 * 1024, formats: 'MP4, WebM, MKV, MOV', maxSize: '20 Go', accept: 'video/mp4,video/webm,video/quicktime,video/*' },
};

// Validate an uploaded file against MEDIA_SPECS (type, format, size, dimensions).
// Returns an error message (string) or null if valid.
export function validateMediaFile(file, field, override) {
  const spec = override || MEDIA_SPECS[field];
  if (!spec || !spec.kind) return Promise.resolve(null);
  const ext = (file.name.split('.').pop() || '').toUpperCase();
  const isImg = file.type.startsWith('image/');
  const isVid = file.type.startsWith('video/');
  if (spec.kind === 'image' && !isImg) {
    return Promise.resolve(`ce champ attend une IMAGE (${spec.formats}), pas ${isVid ? 'une vidéo' : `un fichier « ${file.type || ext} »`}.`);
  }
  if (spec.kind === 'video' && !isVid) {
    return Promise.resolve(`ce champ attend une VIDÉO (${spec.formats}), pas ${isImg ? 'une image' : `un fichier « ${file.type || ext} »`}.`);
  }
  const allowed = (spec.accept || '').split(',');
  const formatOk = allowed.some(a => a === file.type || (a.endsWith('/*') && file.type.startsWith(a.slice(0, -1))));
  if (allowed.length && !formatOk) {
    return Promise.resolve(`format ${ext} non accepté (formats autorisés : ${spec.formats}).`);
  }
  if (spec.maxBytes && file.size > spec.maxBytes) {
    return Promise.resolve(`fichier trop lourd : ${formatFileSize(file.size)} (maximum : ${spec.maxSize}).`);
  }
  if (!spec.w || !spec.h) return Promise.resolve(null);
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const done = (w, h) => {
      URL.revokeObjectURL(url);
      if (!w || !h) return resolve(null);
      if (spec.exact && (w !== spec.w || h !== spec.h)) {
        return resolve(`dimensions incorrectes : ${w} x ${h} px (attendu : ${spec.dims}).`);
      }
      if (!spec.exact && (w < spec.w || h < spec.h)) {
        return resolve(`résolution trop faible : ${w} x ${h} px (minimum : ${spec.dims}).`);
      }
      resolve(null);
    };
    if (spec.kind === 'image') {
      const img = new Image();
      img.onload = () => done(img.naturalWidth, img.naturalHeight);
      img.onerror = () => done(0, 0);
      img.src = url;
    } else {
      const v = document.createElement('video');
      v.preload = 'metadata';
      v.onloadedmetadata = () => done(v.videoWidth, v.videoHeight);
      v.onerror = () => done(0, 0);
      v.src = url;
    }
  });
}

export const LANGUAGES = ['Français', 'Anglais', 'Arabe', 'Espagnol', 'Allemand', 'Italien', 'Portugais', 'Turc', 'Japonais', 'Coréen', 'Chinois', 'Hindi', 'Néerlandais', 'Russe', 'Polonais'];

export const TYPE_LABELS = { fiction: 'Fiction', series: 'Série', documentaire: 'Documentaire', jeunesse: 'Jeunesse', game: 'Jeu' };
export const TYPE_LABELS_PLURAL = { fiction: 'Fictions', series: 'Séries', documentaire: 'Documentaires', jeunesse: 'Jeunesse', game: 'Jeux' };

export function filterStatusOf(item) {
  if (item.filter_status === 'todo') return 'todo';
  if (item.filter_status === 'applied') return 'applied';
  if ((item.content_filters || []).length > 0) return 'applied';
  return null;
}

export function FilterBadge({ item, className = '' }) {
  const st = filterStatusOf(item);
  if (!st) return null;
  return st === 'applied'
    ? <span data-testid={`filter-badge-applied-${item.id}`} className={`px-1.5 py-0.5 rounded text-[9px] font-bold bg-teal-500/90 text-white whitespace-nowrap ${className}`}>Filtres ✓</span>
    : <span data-testid={`filter-badge-todo-${item.id}`} className={`px-1.5 py-0.5 rounded text-[9px] font-bold bg-amber-500/95 text-black whitespace-nowrap ${className}`}>Filtres à mettre</span>;
}

/* Robust S3 upload: simple PUT for small files, multipart for large ones (S3 rejects single PUT > 5 GB with a 400) */
const MULTIPART_THRESHOLD = 500 * 1024 * 1024; // 500 MB
const PART_SIZE = 100 * 1024 * 1024; // 100 MB

function s3ErrorMessage(err) {
  const raw = typeof err.response?.data === 'string' ? err.response.data : '';
  const code = raw.match(/<Code>([^<]+)<\/Code>/)?.[1];
  if (code === 'EntityTooLarge') return 'Fichier trop volumineux pour un envoi simple (limite S3 : 5 Go)';
  if (code) return `Erreur S3 : ${code}`;
  return err.response?.data?.detail || err.message;
}

/* Retry API control calls on 429 (Cloudflare rate limit on the preview domain) */
const RETRY_DELAYS = [3000, 8000, 15000];
async function postRetry(url, body, config) {
  for (let i = 0; ; i++) {
    try { return await axios.post(url, body, config); }
    catch (err) {
      if (err.response?.status !== 429) throw err;
      if (i >= RETRY_DELAYS.length) throw new Error('Limite de requêtes atteinte (protection du domaine de préversion). Patientez ~1 minute puis réessayez.');
      await new Promise(r => setTimeout(r, RETRY_DELAYS[i]));
    }
  }
}

export async function uploadFileToS3(file, onProgress) {
  const contentType = file.type || 'application/octet-stream';
  // Images (except gif/svg): direct PUT to S3 then server-side compression from S3
  // (file bytes never transit through the preview domain -> no Cloudflare rate limit)
  if (contentType.startsWith('image/') && !['image/gif', 'image/svg+xml'].includes(contentType)) {
    const { data: presigned } = await postRetry(`${API}/upload/presign`, { filename: file.name, content_type: contentType }, { withCredentials: true });
    if (presigned.mode !== 'local' && presigned.upload_url !== '__local__') {
      try {
        await axios.put(presigned.upload_url, file, {
          headers: { 'Content-Type': contentType },
          onUploadProgress: (evt) => onProgress?.(Math.min(95, Math.round((evt.loaded * 100) / (evt.total || 1)))),
        });
      } catch (err) {
        throw new Error(s3ErrorMessage(err));
      }
      const { data } = await postRetry(`${API}/upload/compress-image`, { key: presigned.key }, { withCredentials: true });
      onProgress?.(100);
      return data.file_url;
    }
    // Local storage fallback: send through the backend (compresses on the fly)
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await postRetry(`${API}/upload/image`, formData, {
      withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (evt) => onProgress?.(Math.round((evt.loaded * 100) / (evt.total || 1))),
    });
    return data.file_url;
  }
  if (file.size <= MULTIPART_THRESHOLD) {
    const { data: presigned } = await postRetry(`${API}/upload/presign`, { filename: file.name, content_type: contentType }, { withCredentials: true });
    if (presigned.mode === 'local' || presigned.upload_url === '__local__') {
      const formData = new FormData();
      formData.append('file', file);
      const { data: localRes } = await axios.post(`${API}/upload/local`, formData, {
        withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (evt) => onProgress?.(Math.round((evt.loaded * 100) / (evt.total || 1))),
      });
      return localRes.file_url;
    }
    try {
      await axios.put(presigned.upload_url, file, {
        headers: { 'Content-Type': contentType },
        onUploadProgress: (evt) => onProgress?.(Math.round((evt.loaded * 100) / (evt.total || 1))),
      });
    } catch (err) {
      throw new Error(s3ErrorMessage(err));
    }
    return presigned.file_url;
  }

  // Multipart upload (large files)
  const { data: init } = await postRetry(`${API}/upload/multipart/init`, { filename: file.name, content_type: contentType }, { withCredentials: true });
  const totalParts = Math.ceil(file.size / PART_SIZE);
  const parts = [];
  const loaded = new Array(totalParts).fill(0);
  const reportProgress = () => onProgress?.(Math.min(99, Math.round((loaded.reduce((a, b) => a + b, 0) * 100) / file.size)));
  try {
    for (let i = 0; i < totalParts; i++) {
      const partNumber = i + 1;
      const blob = file.slice(i * PART_SIZE, Math.min((i + 1) * PART_SIZE, file.size));
      const { data: pu } = await postRetry(`${API}/upload/multipart/part-url`, { key: init.key, upload_id: init.upload_id, part_number: partNumber }, { withCredentials: true });
      let etag = null;
      for (let attempt = 0; attempt < 3; attempt++) {
        try {
          const res = await axios.put(pu.url, blob, {
            headers: { 'Content-Type': contentType },
            onUploadProgress: (evt) => { loaded[i] = evt.loaded; reportProgress(); },
          });
          etag = res.headers.etag || res.headers.ETag;
          break;
        } catch (err) {
          if (attempt === 2) throw new Error(s3ErrorMessage(err));
        }
      }
      loaded[i] = blob.size;
      reportProgress();
      parts.push({ PartNumber: partNumber, ETag: etag });
    }
    const { data: done } = await postRetry(`${API}/upload/multipart/complete`, { key: init.key, upload_id: init.upload_id, parts }, { withCredentials: true });
    onProgress?.(100);
    return done.file_url;
  } catch (err) {
    axios.post(`${API}/upload/multipart/abort`, { key: init.key, upload_id: init.upload_id }, { withCredentials: true }).catch(() => {});
    throw err;
  }
}

export function formatFileSize(bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} Ko`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} Go`;
}

export function TimecodeInput({ value, onChange, className, light }) {
  const val = value || '00:00:00';
  const parts = val.split(':');
  const hh = (parts[0] || '00').padStart(2, '0').slice(0, 2);
  const mm = (parts[1] || '00').padStart(2, '0').slice(0, 2);
  const ss = (parts[2] || '00').padStart(2, '0').slice(0, 2);
  const groups = [hh, mm, ss];
  const refs = [useRef(), useRef(), useRef()];
  const buffer = useRef('');

  const commit = (idx, raw) => {
    const g = [...groups];
    g[idx] = raw.padStart(2, '0').slice(0, 2);
    onChange(`${g[0]}:${g[1]}:${g[2]}`);
  };

  const handleKey = (idx, e) => {
    if (e.key === 'ArrowLeft' && idx > 0) { e.preventDefault(); buffer.current = ''; refs[idx - 1].current?.focus(); }
    else if (e.key === 'ArrowRight' && idx < 2) { e.preventDefault(); buffer.current = ''; refs[idx + 1].current?.focus(); }
    else if (e.key === ':' && idx < 2) { e.preventDefault(); buffer.current = ''; refs[idx + 1].current?.focus(); }
    else if (e.key === 'Tab') { buffer.current = ''; }
    else if (e.key === 'Backspace') {
      e.preventDefault();
      if (buffer.current.length > 0) { buffer.current = ''; commit(idx, '00'); }
      else if (idx > 0) { buffer.current = ''; refs[idx - 1].current?.focus(); }
    } else if (/^\d$/.test(e.key)) {
      e.preventDefault();
      buffer.current += e.key;
      if (buffer.current.length === 1) commit(idx, '0' + e.key);
      if (buffer.current.length >= 2) {
        commit(idx, buffer.current.slice(-2));
        buffer.current = '';
        if (idx < 2) setTimeout(() => refs[idx + 1].current?.focus(), 0);
      }
    }
  };

  const handleFocus = (idx) => { buffer.current = ''; setTimeout(() => refs[idx].current?.select(), 0); };
  const textCls = light ? 'text-gray-800' : 'text-white';
  const colonCls = light ? 'text-gray-500' : 'text-white/60';

  return (
    <div className={`inline-flex items-center font-mono ${className || ''}`}>
      {groups.map((g, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className={`${colonCls} mx-0.5 select-none font-bold`}>:</span>}
          <input ref={refs[i]} value={g} onKeyDown={e => handleKey(i, e)} onFocus={() => handleFocus(i)} onChange={() => {}}
            className={`w-7 text-center bg-transparent outline-none caret-[#E9641A] ${textCls}`} inputMode="numeric" readOnly={false} />
        </React.Fragment>
      ))}
    </div>
  );
}

export function CountryPicker({ selected, onChange, inputCls, light }) {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const filtered = search ? ALL_COUNTRIES.filter(c => c.toLowerCase().includes(search.toLowerCase())) : ALL_COUNTRIES;
  const toggle = (c) => { onChange(selected.includes(c) ? selected.filter(x => x !== c) : [...selected, c]); };

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1 mb-1.5">
          {selected.map(c => (
            <span key={c} className="flex items-center gap-1 px-2 py-0.5 bg-[#E9641A]/15 text-[#E9641A] rounded text-[9px]">{c}<button type="button" onClick={() => toggle(c)}><X size={8} /></button></span>
          ))}
        </div>
      )}
      <div className="relative">
        <Search size={13} className={`absolute left-2.5 top-1/2 -translate-y-1/2 ${light ? 'text-gray-400' : 'text-white/25'}`} />
        <input value={search} onChange={e => { setSearch(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)}
          placeholder="Rechercher un pays..." className={`w-full rounded-lg pl-8 pr-3 py-2 text-xs focus:outline-none focus:border-[#E9641A] ${inputCls}`} />
      </div>
      {open && (
        <div className={`absolute z-50 mt-1 w-full max-h-52 overflow-y-auto rounded-lg border shadow-lg ${light ? 'bg-white border-gray-200' : 'bg-[#1a0e2e] border-white/10'}`}>
          {filtered.length === 0 && <p className={`px-3 py-2 text-xs ${light ? 'text-gray-400' : 'text-white/30'}`}>Aucun résultat</p>}
          {filtered.map(c => {
            const isSel = selected.includes(c);
            return (
              <button type="button" key={c} onClick={() => toggle(c)}
                className={`w-full text-left px-3 py-1.5 text-xs flex items-center gap-2 transition-colors ${
                  isSel ? light ? 'bg-[#E9641A]/10 text-[#E9641A]' : 'bg-[#E9641A]/10 text-[#E9641A]'
                    : light ? 'text-gray-700 hover:bg-gray-50' : 'text-white/70 hover:bg-white/5'
                }`}>
                <span className={`w-4 h-4 rounded border flex items-center justify-center flex-none ${isSel ? 'bg-[#E9641A] border-[#E9641A]' : light ? 'border-gray-300' : 'border-white/20'}`}>
                  {isSel && <Check size={10} className="text-white" />}
                </span>
                {c}
              </button>
            );
          })}
        </div>
      )}
      <p className={`text-[9px] mt-1 ${light ? 'text-gray-400' : 'text-white/25'}`}>{selected.length} pays sélectionné(s)</p>
    </div>
  );
}

export function FilterSelect({ value, onChange, inputCls }) {
  const [filters, setFilters] = useState([]);
  useEffect(() => {
    fetch(`${API}/admin/filters`, { credentials: 'include' }).then(r => r.json()).then(setFilters).catch(() => {});
  }, []);
  return (
    <select value={value} onChange={e => onChange(e.target.value)} className={`rounded px-2 py-1.5 text-[10px] flex-1 ${inputCls}`}>
      <option value="">-- Type --</option>
      {filters.map(f => <option key={f.id} value={f.id}>{f.name} ({f.action})</option>)}
    </select>
  );
}

export function LoadingSpinner() {
  return <div className="flex justify-center py-20"><div className="w-8 h-8 border-[3px] border-[#E9641A]/30 border-t-[#E9641A] rounded-full animate-spin" /></div>;
}

/* ─── Sélection groupée + suppression (emails, mailbot, support, reports) ─── */
export function BulkBar({ items, selected, setSelected, kind, onDone, light }) {
  const [busy, setBusy] = React.useState(false);
  const ids = items.map(x => x.id).filter(Boolean);
  const all = ids.length > 0 && selected.length === ids.length;
  const del = async () => {
    if (!selected.length || busy) return;
    if (!window.confirm(`Supprimer ${selected.length} élément${selected.length > 1 ? 's' : ''} ? Cette action est définitive.`)) return;
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/bulk-delete`, { kind, ids: selected }, { withCredentials: true });
      toast.success(`${data.deleted} supprimé${data.deleted > 1 ? 's' : ''}`);
      setSelected([]);
      onDone();
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); }
    setBusy(false);
  };
  return (
    <div className="flex items-center justify-between mb-3 flex-wrap gap-2" data-testid={`bulk-bar-${kind}`}>
      <button onClick={() => setSelected(all ? [] : ids)} disabled={!ids.length} data-testid={`bulk-select-all-${kind}`}
        className={`flex items-center gap-1.5 text-xs font-semibold disabled:opacity-40 ${light ? 'text-gray-600 hover:text-gray-900' : 'text-white/60 hover:text-white'}`}>
        {all ? <CheckSquare size={15} className="text-[#E9641A]" /> : <Square size={15} />}
        {all ? 'Tout désélectionner' : 'Tout sélectionner'} {selected.length > 0 && `(${selected.length})`}
      </button>
      <button onClick={del} disabled={!selected.length || busy} data-testid={`bulk-delete-${kind}`}
        className="flex items-center gap-1.5 bg-red-500/90 hover:bg-red-500 text-white text-xs font-semibold px-4 py-2 rounded-lg transition-colors disabled:opacity-30">
        <Trash2 size={13} /> {busy ? 'Suppression…' : `Supprimer la sélection${selected.length ? ` (${selected.length})` : ''}`}
      </button>
    </div>
  );
}

export function BulkCheck({ id, selected, setSelected, light }) {
  const on = selected.includes(id);
  return (
    <button onClick={(e) => { e.stopPropagation(); setSelected(s => on ? s.filter(x => x !== id) : [...s, id]); }}
      data-testid={`bulk-check-${id}`} className="flex-none p-1 mt-0.5">
      {on ? <CheckSquare size={16} className="text-[#E9641A]" /> : <Square size={16} className={light ? 'text-gray-300' : 'text-white/25'} />}
    </button>
  );
}
